import { RFI_ALLOWED_ITEMS, RFI_STATUS, PENDING_FOR_HOURS_OPTIONS } from './constants';
import { FIELD_SIZE, INPUT_FIELD_TYPE, INPUT_TYPE } from '@components/DynamicFormField/constant';
import { updateUserDetails } from '@store/actions/cxOperationActions';


export const getRFIStatusColor = (status) => {
  if (status === RFI_STATUS.VERIFIED) return 'green';
  else if (
    status === RFI_STATUS.EXPIRED ||
    status === RFI_STATUS.FAILED ||
    status === RFI_STATUS.REJECTED
  )
    return 'red';
  else return 'yellow.500';
};

export const getPendingForHoursOptions = () =>
  PENDING_FOR_HOURS_OPTIONS.map((hour) => ({
    value: String(hour),
    label: `${hour} ${hour === 1 ? 'hour' : 'hours'}`
  }));

export const getRfiRequestedItems = () => {
  return Object.keys(RFI_ALLOWED_ITEMS).flatMap((requestForKey) =>
    RFI_ALLOWED_ITEMS[requestForKey].flatMap((info) => ({
      requestedFor: requestForKey,
      requestedInfo: info.requestedInfo,
      title: info.title
    }))
  );
};

/**
 *
 * @type {{title: string, updateBeneficiaryFieldsConfig: (function(): *)}}
 */
const getUpdateKycNameFieldsConfig = () => {
  return [
    {
      key: "kycName",
      name: "kycName",
      value: "",
      label: `KYC Name`,
      caption: null,
      placeholder: "Enter the User KYC Name",
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      fieldSize: FIELD_SIZE.MEDIUM,
      maxLength: 55,
      width: 'auto',
      isEditable: true,
      isRequired: true,
    }
  ];
};

const payloadConverter = ({
  formData,
}) => {
  return {
    fieldName: "kycName",
    fieldValue: formData?.kycName
  }
}

export const rfiKycConfig = {
  title: 'RFI KYC Name Update',
  updateUpdateKycNameFieldsConfig: () => getUpdateKycNameFieldsConfig(),
  userKycNamePayloadConverter: ({formData}) => payloadConverter({formData}),
  updateUserKycName: ({ userId, fieldName = 'kycName', fieldValue, onSuccess, onComplete}) => updateUserDetails({
    userId,
    fieldName,
    fieldValue,
    onSuccess,
    onComplete
  }),
}
